const configs = {
  production: {
    api: "https://metricsapi.gpoptima.info/",
    logger: true,
    socket_io_url: "http://localhost:8000"
  },
  dev: {
    api: "https://devmetricsapi.gpoptima.info/",
    logger: true,
    socket_io_url: "http://localhost:8000"
  },
  local: {
    api: "http://localhost:8183/",
    logger: true,
    socket_io_url: "http://localhost:8000"
  },
  test: {
    api: "http://x4s0gccw0g4s44cg4wckg08s.164.92.88.77.sslip.io/",
    logger: true,
    socket_io_url: "http://localhost:8000"
  }
};

const mode = process.env.REACT_APP_MODE || "production";

export default configs[mode];